import React, { Component } from 'react';
import { Reps } from './rep-marker';
import { Agents } from './agent-marker';

class MarkerLoader extends Component {
    components = {
        sales_reps: Reps,
        service_agents: Agents
    };
    render() {
       const TagName = this.components[this.props.tag || 'reps'];
       return <TagName />
    }
}
export default MarkerLoader;
